import api from '@/apis/di/topicAPI.js';
import Crud from '@/stores/crudBaseCache.js';

var crud = new Crud('topic', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_topic',
    field: {
      key: 'topic_id',
      code: 'topic_code',
      name: 'topic_name',
      quickFollow: 'inactive',
    },
    defaultSort: 'misa_code_id',
  },
};

const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
  /**
   * Cập nhật khi thêm bản ghi 
   */

  insertItem(state, data) {
    crud.mutations.insertItem(state, data);
    let parent = state.items.find(x => x.topic_code == data.parent_code);
    if (parent) {
      parent.is_parent = true;
    }
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
